<template>
  <div class="content text-center">
       <div class="table-container">

         <el-row>
           <el-col :span="2" class="text-left" style="width:100%; background: rgb(240, 240, 240);">
            <div style="top:29px;left:10px;z-index: 20;" >   
            <el-input style="top:-1px;left:20px;z-index: 20;width:170px"
                  v-model="search"
                  size="mini"
                  placeholder="Rechercher"/>
              </div>
           </el-col>

        </el-row>
       
       <el-table 
        :data="tableDataComputedTAche" :cell-class-name="tableRowClassName"
         :row-class-name="tableRowClassName"
         style="width:100%;"
          height=85%
          stripe
          
             class="tableCenter"
      >
 
    <el-table-column
      prop="VENDEUR"
      label="Commercial"
      width="120"
      text-align= "center"
      sortable>
    </el-table-column>

         <el-table-column
           prop="NOM_CLI"
           min-width="130"
           label="Nom client"
           sortable>
         </el-table-column>

    <el-table-column
           prop="NUM_ACTION"
           label="Action"
           width="100"
           sortable>
         </el-table-column>

         <el-table-column
           prop="LIB_OBJET"
           label="Objet"
           min-width="100"
           sortable>
         </el-table-column>
    
         <el-table-column
           prop="RESSOURCE"
           label="Intervenant"
           width="120"
           sortable>
         </el-table-column>
          <el-table-column
           prop="TACHE"
           label="Tache"
           width="350"
           sortable>
         </el-table-column>
          <el-table-column
           prop="DTE_PREV2"
           label="Prévue le"
           width="110"
           sortable>
         </el-table-column>
         <el-table-column
           prop="DTE_REAL2"
           label="Réalisée le"
           width="112"
           sortable>
         </el-table-column>
          
           </el-table>
           <div class="block">
    
    <el-pagination
       @size-change="handleSizeChangePagination"
      @current-change="handleCurrentChangePagination"
      :page-size="table_size"
      layout="sizes,prev, pager, next, jumper"
      :total="count_table">
    </el-pagination>
  </div>
      </div>
      </div>

</template>
<script>


  import axios from 'axios';
  import $ from 'jquery'; 
  import {BACKEND_URL} from './GLOBALS'
import Vue from 'vue'
 
const moment = require('moment')
require('moment/locale/fr')

Vue.use(require('vue-moment'), {
    moment
}) 
  
  export default {
      name:'Taches',
    components: {
    },
    data () {
      return {
        table_index:0,
        table_size:10,
count_table:0,
        tableData: [],
          numAct:{},
          search:'',
          
    
      
     
      }
    },
    computed: {
      // a computed getter
      tableDataComputedTAche: function () {
        // console.log('tableData')
        // console.log(this.tableData)
                
        let resultSearch= this.tableData.map(element=>{
            return {
              IDConcat :element.IDConcat == null?'' :element.IDConcat  ,
              VENDEUR:element.VENDEUR == null?'' :element.VENDEUR  ,
              NOM_CLI :element.NOM_CLI == null?'' :element.NOM_CLI  ,
              RESSOURCE:element.RESSOURCE == null?'' :element.RESSOURCE  ,
              TACHE:element.TACHE == null?'' :element.TACHE  ,   
              DTE_PREV2:element.DTE_PREV2 == null?'' :element.DTE_PREV2  ,
              DTE_REAL2:element.DTE_REAL2 == null?'' :element.DTE_REAL2  ,
              PROSPECT:element.PROSPECT == null?'' :element.PROSPECT  ,
              NUM_ACTION:element.NUM_ACTION == null?'' :element.NUM_ACTION  ,
              LIB_OBJET:element.LIB_OBJET == null?'' :element.LIB_OBJET  ,
            }
        })
        // console.log('resultSearch Tache');
        // console.log(resultSearch );
        resultSearch=  resultSearch.filter(data => !this.search ||
          data.IDConcat.toLowerCase().includes(this.search.toLowerCase()) ||
          data.VENDEUR.toLowerCase().includes(this.search.toLowerCase()) ||
          data.NOM_CLI.toLowerCase().includes(this.search.toLowerCase()) ||
          data.RESSOURCE.toLowerCase().includes(this.search.toLowerCase()) ||
          data.TACHE.toLowerCase().includes(this.search.toLowerCase()) ||
          data.DTE_PREV2.toLowerCase().includes(this.search.toLowerCase()) ||
          data.DTE_REAL2.toLowerCase().includes(this.search.toLowerCase()) 
        )
        this.count_table=resultSearch.length;
        return resultSearch.slice(this.table_index*this.table_size, (this.table_index + 1)*this.table_size) 
      }
     },
     mounted (){
      let btn_next  = document.getElementsByClassName("btn-next")[0];
      btn_next.style = "margin-top:7px";
      let btn_prev  = document.getElementsByClassName("btn-prev")[0];
      btn_prev.style = "margin-top:7px";
     },
    methods:{
      handleSizeChangePagination(val){
        this.table_size=val;
      },
        handleCurrentChangePagination(val){
            this.table_index=val;
        },
     tableRowClassName({row, column, rowIndex, columnIndex}) {
         /* console.log(row)
          console.log(column)
          console.log(rowIndex)
          console.log(columnIndex)
        if (row.PROSPECT === '0' ) {
          return 'test';
        } else if (row.PROSPECT === '0' ) {
          return '';
        }*/
        if(columnIndex == 2 && row.PROSPECT == '0'){
          return 'black'
        }else if (columnIndex == 2 && row.PROSPECT == '1'){
          return 'blue'
        }


        return '';
      
    },
    },
     created() {

        $.ajaxSetup({
            data: {
              'sessionId': this.$store.getters.sessionId,
            },
          });
       
       var self= this
        var request = $.ajax({
            url: BACKEND_URL+"controller/liste_Taches.php",
            async: false,
            type: "POST",
            data: {
              'listeTAches':1
            },
            dataType: "html",
            success: function(data) {
                
               
                var dataParsed = JSON.parse(data)
                
                  self.tableData=dataParsed
               

            }
        })


    }
  }
  
</script>
<style type="text/css">
 .blue {
    color: blue!important;
  }
</style>